import { UnfilledHeart as UnfilledHeart_kojaro } from './UnfilledHeart.kojaro';
import { UnfilledHeart as UnfilledHeart_phosphor } from './UnfilledHeart.phosphor';
import { UnfilledHeart as UnfilledHeart_zoomg } from './UnfilledHeart.zoomg';
import { UnfilledHeart as UnfilledHeart_zoomit } from './UnfilledHeart.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return UnfilledHeart_kojaro;

    case 'zoomg':
      return UnfilledHeart_zoomg;

    case 'phosphor':
      return UnfilledHeart_phosphor;

    default:
      return UnfilledHeart_zoomit;
  }
};

export const UnfilledHeart = IconRenderer();
